import { create } from "zustand";

const useStore = create((set) => ({
    message:{type:null, label:null},//submitPopup메세지출력

    setMessage: (message) => set((state) => ({ ...state, message })),
}));

export default useStore;
